// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { TriggerValueOverride, ITriggerValueOverride } from "./Shared.Models.Api.V1.DeviceCommands.TriggerValueOverride.gen";

export interface IDriverOverrideState {
	triggerEnabled: { [key: string]: boolean } | undefined;

	triggerValues: { [key: string]: ITriggerValueOverride } | undefined;

	leftPassLanes: number | undefined;

	rightPassLanes: number | undefined;

	sidePassMinSpeed: number | undefined;

	snoozedRelay: number | undefined;

	snoozeSecondsRemaining: number | undefined;

	snoozeUntilUtc: string | undefined;

	$type?: string | undefined;
}
export class DriverOverrideState {
	constructor(data?: IDriverOverrideState) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
		if (data.snoozeUntilUtc) { this.snoozeUntilUtc = new Date(data.snoozeUntilUtc); }
	}

	triggerEnabled: { [key: string]: boolean } | undefined;

	triggerValues: { [key: string]: TriggerValueOverride } | undefined;

	leftPassLanes: number | undefined;

	rightPassLanes: number | undefined;

	sidePassMinSpeed: number | undefined;

	snoozedRelay: number | undefined;

	snoozeSecondsRemaining: number | undefined;

	snoozeUntilUtc: Date | undefined;

	static $type: string = "Shared.Models.Api.V1.DriverOverrideState, ";
	$type?: string | undefined = DriverOverrideState.$type;
}

